const UseFormLifecycleUtils = module.exports = {};

UseFormLifecycleUtils.DEFAULT_SCROLL_DELAY_MS = 500;

UseFormLifecycleUtils.buildLocationStateActions = ({ locationState } = {}) => {

    return {
        shouldScrollToInterests: !!locationState?.scrollToInterests,
        successRedirectPath: locationState?.returnTo || null
    };
};

UseFormLifecycleUtils.buildSuccessRedirectState = (successRedirectPath) => {

    return {
        successRedirectPath
    };
};

UseFormLifecycleUtils.buildInitialStateWithLocationState = ({
    initialState,
    locationState
}) => {

    const { successRedirectPath } = UseFormLifecycleUtils.buildLocationStateActions({
        locationState
    });

    if (!successRedirectPath) {
        return initialState;
    }

    return {
        ...initialState,
        ...UseFormLifecycleUtils.buildSuccessRedirectState(successRedirectPath)
    };
};

UseFormLifecycleUtils.focusFieldElement = (fieldEl) => {

    if (!fieldEl) {
        return false;
    }

    if (typeof fieldEl.scrollIntoView === 'function') {
        fieldEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
    }

    if (typeof fieldEl.focus === 'function') {
        fieldEl.focus();
        return true;
    }

    return false;
};

UseFormLifecycleUtils.scheduleFocusFieldElement = ({
    fieldEl,
    scheduler = setTimeout,
    delayMs = UseFormLifecycleUtils.DEFAULT_SCROLL_DELAY_MS
}) => {

    scheduler(() => UseFormLifecycleUtils.focusFieldElement(fieldEl), delayMs);
};
